var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.company)?_c('router-link',{attrs:{"to":{ name: 'CompanyShow', params: {id: _vm.data.company['@id']} }}},[_vm._v("\n  "+_vm._s(_vm.data.company.code)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30af1876","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/table/ColumnCompanyCode.vue
// module id = 859
// module chunks = 0